"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const GHOST_STORAGE_ERROR_MESSAGE = 'This is a ghost storage this code should not have ran!';
class GhostStorage {
    constructor(account = 'Bitloops') {
        this.account = account;
    }
    async saveSessionUuid(sessionId) {
        const error = new Error(GHOST_STORAGE_ERROR_MESSAGE + sessionId);
        // console.log('error', error);
        return Promise.resolve();
    }
    async getSessionUuid() {
        const error = new Error(GHOST_STORAGE_ERROR_MESSAGE);
        // console.log(error);
        return Promise.resolve(null);
    }
    async deleteSessionUuid() {
        const error = new Error(GHOST_STORAGE_ERROR_MESSAGE);
        // console.log(error);
        return Promise.resolve();
    }
    async saveUser(bitloopsUser) {
        const error = new Error(GHOST_STORAGE_ERROR_MESSAGE + JSON.stringify(bitloopsUser));
        // console.log(error);
        return Promise.resolve();
    }
    async getUser() {
        const error = new Error(GHOST_STORAGE_ERROR_MESSAGE);
        // console.log(error);
        return Promise.resolve(null);
    }
    async deleteUser() {
        const error = new Error(GHOST_STORAGE_ERROR_MESSAGE);
        // console.log(error);
        return Promise.resolve();
    }
}
exports.default = GhostStorage;
//# sourceMappingURL=GhostStorage.js.map